import { useContext } from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import { ProfilIcon } from 'app/components/commons/icons/DefaultProfile';
import type { GiftCardDetails } from 'app/typings/giftCard';
import { format as formatDate } from 'app/utils/dayjs';

type Props = {
  giftCardDetails: GiftCardDetails;
};

export const Sender: FC<Props> = ({ giftCardDetails }: Props) => {
  const { giftCards, staycations, user: sender } = giftCardDetails;
  const {
    gender,
    firstName,
    lastName,
    id: senderId,
    avatarPath,
    birthDate,
  } = sender;

  const { currencyFormatter } = useContext(CurrencyContext);

  const getUserName = () => {
    if (!firstName || !lastName) {
      return `#${senderId}`;
    }

    return gender === undefined || gender === 'Other'
      ? `${firstName} ${lastName}`
      : `${gender} ${firstName} ${lastName}`;
  };

  const amount = staycations.reduce((a, b) => a + b, 0);

  const myStaycations = [
    `${staycations.length} booking${staycations.length > 0 ? 's' : ''}`,
    `${giftCards.length} card${giftCards.length > 0 ? 's' : ''}`,
    `${currencyFormatter(amount)}`,
  ].join(' • ');

  return (
    <div className="bloc">
      <div className="title">Sender</div>
      <div className="user-content">
        {avatarPath ? (
          <PictureComponent
            className="avatar"
            style={{ borderRadius: '50%' }}
            pictureId={avatarPath}
          />
        ) : (
          <ProfilIcon />
        )}
        <div className="details">
          <div className="name">
            <Link
              className="link"
              to={`/users/${senderId}/edit`}
              target="_blank"
            >
              {getUserName()}
            </Link>
          </div>
          {!!birthDate && (
            <div className="birth-date">
              {formatDate(new Date(birthDate), 'DD/MM/YYYY ')}
            </div>
          )}
          <div className="staycations">{myStaycations}</div>
        </div>
      </div>
    </div>
  );
};
